<template>
  <div class="report-user-content">

    <b-card no-body class="card-analytics-system-content">
      <b-card-header class="statistics-filter-header">
        {{ $t('STATISTICS.Filter') }}
      </b-card-header>
      <b-card-body class="report-user-content-filter" v-if="displayFilters">
        <div class="row">

          <div class="col-md-6">
            <!-- datepicker -->
            <div class="d-flex align-items-center calendar-analytics-report-by-user">
              <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
              <flat-pickr
                :key="`period-${$i18n.locale}`"
                v-model="rangePicker"
                class="form-control-sm form-date"
                :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                :config="{
                  enableTime: false,
                  dateFormat: 'Y-m-d',
                  altInput: true,
                  altFormat: 'd/m/Y',
                  allowInput: true,
                  mode: 'range',
                }"
              />
            </div>
            <!-- datepicker -->
          </div>

          <div class="col-md-6 user-filter">
            <b-form-group>
              <v-select
                id="subject-list"
                v-model="userFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                class="form-control-sm"
                :placeholder="$t('MANAGE_NEWS_FILTER.User')"
                :options="users"
                multiple
                :closeOnSelect="false"
              >
                <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
              </v-select>
            </b-form-group>
          </div>
          
          <div class="col-md-6">
            <b-form-group>
              <v-select
                id="event-status-list"
                v-model="eventStatusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                class="form-control-sm"
                :placeholder="$t('MANAGE_NEWS_FILTER.EventStatus')"
                :options="eventStatus"
              >
                <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
              </v-select>
            </b-form-group>
          </div>

          <!-- <div class="col-md-12"></div> -->
        </div>
        <div class="search-button-report-by-user">
          <b-button 
            variant="primary" 
            size="sm" 
            @click="fetchAllData()"
          >
          {{ $t("MANAGE_NEWS_FILTER.Search") }}
          </b-button>
          <b-button 
            variant="primary"
            size="sm" 
            @click="onClear"
          >
            <feather-icon icon="TrashIcon" class="export-button-icon"/>
            {{ $t('MANAGE_NEWS_FILTER.Clear') }}
          </b-button>
        </div>
        
          <!-- <div>
          </div> -->
      </b-card-body>
    </b-card>
    <vue-perfect-scrollbar
      class="report-user-scroll-area repor-by-user"
      :suppressScrollX="true"
    >
      <div class="row">
        <!-- <div class="col-md-12">
          <b-form-group>
            <v-select
              id="origin-list"
              v-model="originFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              class="form-control-sm"
              :placeholder="$t('MANAGE_NEWS_FILTER.Origin')"
              :options="origins"
              multiple
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-form-group>
        </div> -->

        <!-- <div class="col-md-12">
          <b-form-group>
            <v-select
              id="subject-list"
              v-model="subjectFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              class="form-control-sm"
              :placeholder="$t('MANAGE_NEWS_FILTER.Subject')"
              :options="subjects"
              multiple
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-form-group>
        </div> -->
        

        <!-- <div class="col-md-12">
          <b-form-group>
            <v-select
              id="subject-list"
              v-model="agencyFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              class="form-control-sm"
              :placeholder="$t('MANAGE_NEWS_FILTER.Agency')"
              :options="agency"
              multiple
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-form-group>
        </div>

        <div class="col-md-12">
          <b-form-group>
            <v-select
              id="layout-list"
              v-model="layoutFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              class="form-control-sm"
              :placeholder="$t('MANAGE_NEWS_FILTER.User')"
              :options="layouts"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-form-group>
        </div>

          -->

        <!-- <div class="col-md-12">
          
        </div> -->

        <!-- <div class="col-md-12">
          <b-card no-body>
            <b-card-header>
              <b-card-sub-title class="mb-25">
                Minhas estatisticas
              </b-card-sub-title>

              <div class="d-flex align-items-center">
                <feather-icon icon="CalendarIcon" size="16" />
                <flat-pickr
                  v-model="rangePickerReportCurrentUser"
                  class="form-control-sm form-date"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                  :config="{
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                    allowInput: true,
                    mode: 'range',
                  }"
                />
              </div>
            </b-card-header>

            <b-card-body>
              <b-overlay class="custom-overlay" :show="displayOverlayUserReport" rounded="sm">
                <div>
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="fetchCurrentUserReport()"
                  >
                    Buscar
                  </b-button>
                </div>
                <vue-apex-charts
                  v-if="displayChartCurrentUser"
                  type="bar"
                  height="350"
                  :options="barChartCurrentUser.chartOptions"
                  :series="barChartCurrentUser.series"
                />
              </b-overlay>
            </b-card-body>
          </b-card>
        </div> -->

        <div class="col-md-12">
          <b-card no-body>
            <b-card-header>
              <!-- title and subtitle -->
              <b-card-sub-title class="mb-25">
                {{$t('STATISTICS.Report_Total_By_User')}}
              </b-card-sub-title>
              <b-button
                variant="primary"
                size="sm"
                @click="reportData()"
                v-if="displayTableReport"
              >
                <feather-icon icon="FileTextIcon" class="export-button-icon"/>
                {{$t('GENERAL.Export')}}
              </b-button>
              <!--/ title and subtitle -->

            </b-card-header>

            <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
              <b-card-body>
                <custom-g-table
                  v-if="displayTableReport"
                  ref="custom-table"
                  :fields="fieldsReport"
                  :items="reportUser"
                />
                <!-- <vue-apex-charts
                  v-if="displayChart"
                  type="bar"
                  height="350"
                  :options="barChart.chartOptions"
                  :series="barChart.series"
                /> -->
              </b-card-body>
            </b-overlay>
          </b-card>
          <!-- <b-card no-body class="card-employee-task">
            <b-card-header>
              <b-card-title>Usuários</b-card-title>
            </b-card-header>

            <app-collapse
              accordion
              type="margin"
              not-arrow
            >
              <app-collapse-item title="" v-for="(item, index) in listData.data" :key="index">
                <div slot="header" class="d-flex
                  justify-content-between
                  align-items-center">
                  <b-media no-body>
                    <b-media-aside class="mr-75">
                      <b-avatar v-if="item.user.image_path" rounded size="42" :src="item.user.image_path" />
                      <b-avatar
                        v-if="!item.user.image_path"
                        :text="item.user.name"
                        size="42"
                        variant="light-secondary"
                        class="mr-1"
                      />
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h6 class="mb-0">
                        {{ item.user.name }}
                      </h6>
                      <small>{{ getProfile(item.user.profile) }}</small>
                    </b-media-body>
                  </b-media>
                  <div class="d-flex align-items-center" style="right: 0;position: absolute;margin-right: 10px;">
                    <small class="text-muted mr-75">{{
                      item.total
                    }}</small>
                  </div>
                </div>
                
                <app-collapse type="shadow">
                  <app-collapse-item v-for="(news) in item.news" :key="news._id" title="">
                    <div slot="header">
                      {{news.content.title.data}}
                    </div>
                    <div>
                      <p>Data Criação: {{news.dt_create}}</p>
                      <p>Data Publicação: {{news.dt_publish}}</p>
                      <p>Data Agendamento: {{news.dt_scheduled}}</p>
                    </div>
                  </app-collapse-item>
                </app-collapse>
              </app-collapse-item>
            </app-collapse>
          </b-card> -->
        </div>

        <div class="col-md-12">
          <b-card no-body>
            <b-card-header>
              <!-- title and subtitle -->
              <b-card-sub-title class="mb-25">
                {{$t('STATISTICS.Report_By_User_And_Date')}}
              </b-card-sub-title>
              <!--/ title and subtitle -->
            </b-card-header>
            <b-overlay class="custom-overlay" :show="displayOverlayBydate" rounded="sm" v-if="displayOverlayBydate">
              <b-card-body>
                <app-collapse
                  accordion
                  type="margin"
                  not-arrow
                >
                <div v-if="reportUserByDate && reportUserByDate.length > 0">
                  <app-collapse-item
                    title="" 
                    v-for="(item, index) in reportUserByDate" 
                    :key="index"
                  >
                    <div 
                      v-if="item"
                      slot="header" 
                      class="d-flex justify-content-between align-items-center"
                      @click="toggleCard(index)"
                    >
                      {{ item.user ? item.user.name : '' }}
                      <span >
                        <feather-icon :icon="getChevronIcon(index)" size="18"/>
                      </span>
                    </div>
                    <div v-if="item">
                    <user-report-table-by-date 
                      :data="item"
                      @fetch-report="fetchReportByDate"
                    />
                  </div>
                  </app-collapse-item>
                </div>
                </app-collapse>
                
                <div v-if="item">
                  <user-report-table-by-date 
                    :data="item"
                    @fetch-report="fetchReportByDate"
                  />
                </div>
              </b-card-body>
              <!-- <div class="ml-2 mb-2">
              <b-button
                variant="primary"
                size="sm"
                @click="fetchReportByDate()"
              >
                Buscar
              </b-button>
            </div> -->
            
              <!-- <b-card-body v-for="(item, key) in barChartByDate" :key="key" style="border: 1px solid;">
                <b-media no-body v-if="item.user">
                  <b-media-aside class="mr-75">
                    <b-avatar v-if="item.user.image_path" rounded size="42" :src="item.user.image_path" />
                    <b-avatar
                      v-if="!item.user.image_path"
                      :text="item.user.name"
                      size="42"
                      variant="light-secondary"
                      class="mr-1"
                    />
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ item.user.name }}
                    </h6>
                    <small>{{ getProfile(item.user.profile) }}</small>
                  </b-media-body>
                </b-media>
                
                <vue-apex-charts
                  v-if="item"
                  type="bar"
                  height="350"
                  :options="item.chartOptions"
                  :series="item.series"
                />
              </b-card-body> -->
            </b-overlay>
          </b-card>
        </div>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardSubTitle,
  // BBadge,
  BFormGroup,
  // BMediaBody,
  // BAvatar,
  // BMediaAside,
  // BMedia,
  // BCardTitle,
  BButton,
  BOverlay
  // BRow,
  // BCol
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
// import VueApexCharts from "vue-apexcharts";
// import { $themeColors } from "@themeConfig";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import newsReportService from "@/providers/newsReportService";
import { ref, onMounted } from "@vue/composition-api";
import dropdownService from "@/providers/dropdownService";
import AppConstants from "@/appConstants";
import vSelect from "vue-select";
// import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import UserReportTableByDate from "./UserReportTableByDate.vue";

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    VuePerfectScrollbar,
    // VueApexCharts,
    BCardHeader,
    BCard,
    // BBadge,
    BCardBody,
    BCardSubTitle,
    flatPickr,
    BFormGroup,
    vSelect,
    // BMediaBody,
    // BAvatar,
    // BMediaAside,
    // BMedia,
    // BCardTitle,
    BButton,
    BOverlay,
    CustomGTable,
    UserReportTableByDate
    // BRow,
    // BCol
  },
  data() {
    return {
      openItems: {},
    };
  },
  computed: {

  },
  watch: {
  },
  methods: {
    toggleCard(index) {
      this.$set(this.openItems, index, !this.openItems[index]);
    },
    getChevronIcon(index) {
      return this.openItems[index] ? 'ChevronUpIcon' : 'ChevronDownIcon';
    },
    getProfile(profile) {
      switch (profile) {
        case AppConstants.USER_PROFILE.ADMIN:
          return this.$t('PROFILE.Admin');
        case AppConstants.USER_PROFILE.PUBLISHER:
          return this.$t('PROFILE.Publisher');
        case AppConstants.USER_PROFILE.JOURNALISM:
          return this.$t('PROFILE.Journalism');
        case AppConstants.USER_PROFILE.ATTENDANCE:
          return this.$t('PROFILE.Attendance');
        case AppConstants.USER_PROFILE.CONTRACT:
          return this.$t('PROFILE.Contract');
        case AppConstants.USER_PROFILE.CONSULTING:
          return this.$t('PROFILE.Consulting');
        case AppConstants.USER_PROFILE.EDITOR:
          return this.$t('PROFILE.Editor');
      }
      return '';
    },
  },
  setup() {
    // filter
    // const displayOverlayUserReport = ref(false);
    const displayOverlayBydate = ref(false);
    const displayOverlay = ref(false);
    const displayFilters = ref(false);

    onMounted(() => {
      displayFilters.value = true;
    });
    // const displayChartByDate = ref(false);
    // const displayChartCurrentUser = ref(false);
    // const displayChart = ref(false);
    // const rangePicker = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const rangePicker = ref("");
    // const rangePickerReportCurrentUser = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    // const rangePickerReportByDate = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const origins = ref([]);
    const subjects = ref([]);
    const users = ref([]);
    const eventStatus = ref([]);
    const layouts = ref(AppConstants.LIST_TEMPLATE);
    const agency = ref(AppConstants.USER_AGENCY);

    const originFilter = ref([]);
    const subjectFilter = ref([]);
    const userFilter = ref([]);
    const agencyFilter = ref([]);
    const importantFilter = ref(false);
    const flashesFilter = ref(false);
    const eventStatusFilter = ref("");
    const layoutFilter = ref(AppConstants.LIST_TEMPLATE[0]);

    const reportUser = ref([]);
    const reportUserByDate = ref([]);

    const pageReport = ref(1);
    const pageReportByDate = ref(1);
    const displayTableReport = ref(false);
    const displayTableReportByDate = ref(false);
    const totalRowsReport = ref(0);
    const totalRowsReportByDate = ref(0);
    const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT);

    // CHART VARIABLES
    // const defaultBarChart = ref({
    //   user: null,
    //   series: [
    //     {
    //       data: [],
    //     },
    //   ],
    //   chartOptions: {
    //     chart: {
    //       stacked: true,
    //       toolbar: {
    //         show: true,
    //       },
    //     },
    //     colors: $themeColors.info,
    //     plotOptions: {
    //       bar: {
    //         horizontal: false,
    //         columnWidth: '15%',
    //         barHeight: "30%",
    //         endingShape: "rounded",
    //         backgroundBarRadius: 10,
    //       },
    //     },
    //     grid: {
    //       xaxis: {
    //         lines: {
    //           show: true,
    //         },
    //       },
    //     },
    //     dataLabels: {
    //       enabled: true,
    //     },
    //     legend: {
    //       show: true,
    //       position: 'top',
    //       fontSize: '14px',
    //       fontFamily: 'Montserrat',
    //       horizontalAlign: 'left',
    //     },
    //     stroke: {
    //       show: false,
    //       colors: ['transparent'],
    //     },
    //     xaxis: {
    //       categories: [],
    //     },
    //     yaxis: {
    //       // opposite: isRtl,
    //     },
    //   },
    // });

    // const barChart = ref({});
    // const barChartCurrentUser = ref({});
    // const barChartByDate = ref([]);

    // barChart.value = Object.assign({}, defaultBarChart.value);
    // barChartCurrentUser.value = Object.assign({}, defaultBarChart.value);
    // const barChartCurrentUser = ref({
    //   series: [
    //     {
    //       data: [],
    //     },
    //   ],
    //   chartOptions: {
    //     chart: {
    //       zoom: {
    //         enabled: false,
    //       },
    //       toolbar: {
    //         show: true,
    //       },
    //     },
    //     markers: {
    //       strokeWidth: 7,
    //       strokeOpacity: 1,
    //       strokeColors: [$themeColors.light],
    //       colors: [$themeColors.warning],
    //     },
    //     colors: $themeColors.info,
    //     grid: {
    //       xaxis: {
    //         lines: {
    //           show: true,
    //         },
    //       },
    //     },
    //     dataLabels: {
    //       enabled: true,
    //     },
    //     stroke: {
    //       curve: 'straight',
    //     },
    //     xaxis: {
    //       categories: [],
    //     },
    //     yaxis: {
    //       // opposite: isRtl,
    //     },
    //   },
    // });

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };

    const fieldsReport = [
      {
        field: "user.name",
        label: "Usuário",
        sortable: false,
      },
      {
        field: "total",
        label: "Total de Publicações",
        sortable: false,
      },
    ];

    // const getCurrentDate = () => {
    //   rangePicker.value = 
    // }

    const onChangePageReport = (newPage) => {
      pageReport.value = newPage;
      fetchReport();
    };

    const onChangePageReportByDate = (newPage) => {
      pageReportByDate.value = newPage;
      fetchReportByDate();
    };


    const fetchFilter = () => {
      const originParams = new URLSearchParams();
      originParams.append("legacy", true);

      const subjectParams = new URLSearchParams();
      subjectParams.append(AppConstants.PARAMS_USER_FILTER, true);

      Promise.all([
        dropdownService.getAllOrigin(originParams),
        dropdownService.getAllSubjects(subjectParams),
        dropdownService.getUsers(new URLSearchParams()),
        dropdownService.getEventStatus(new URLSearchParams()),
      ]).then((resp) => {
        origins.value = resp[0];
        subjects.value = resp[1];
        users.value = resp[2];
        eventStatus.value = resp[3];
        // eventStatusFilter.value = eventStatus.value[0];
        // fetchReport();
      });
    };

    const buildParams = () => {
      const params = new URLSearchParams();

      params.append("page", pageReport.value);
      params.append("limit", limit.value);

      if (originFilter.value) {
        params.append(
          "source",
          originFilter.value.map((item) => item.id).join(",")
        );
      }
      if (subjectFilter.value) {
        params.append(
          "subject",
          subjectFilter.value.map((item) => item.id).join(",")
        );
      }
      if (userFilter.value.length > 0) {
        params.append(
          "users",
          userFilter.value.map((item) => item.id).join(",")
        );
      }
      if (agencyFilter.value.length > 0) {
        params.append(
          "agency",
          agencyFilter.value.join(",")
        );
      }
      if (importantFilter.value) {
        params.append("importance", true);
      }
      if (flashesFilter.value) {
        params.append("flashes", true);
      }
      if (eventStatusFilter.value) {
        params.append("event_status", eventStatusFilter.value.id);
      }
      if (layoutFilter.value) {
        if (layoutFilter.value.id != AppConstants.LIST_TEMPLATE[0].id) {
          params.append("layout", eventStatusFilter.value);
        }
      }
      
      return params;
    };

    // const fetchCurrentUserReport = () => {
    //   displayChartCurrentUser.value = false;
    //   displayOverlayUserReport.value = true;
    //   barChartCurrentUser.value.series[0].data = [];
    //   barChartCurrentUser.value.chartOptions.xaxis.categories = [];
    //   const params = buildParams();
    //   if (rangePickerReportCurrentUser.value) {
    //     params.append("dt_range", rangePickerReportCurrentUser.value);
    //   }
    //   newsReportService.getCurrentUserReport(params).then((resp) => {

    //     for (let index = 0; index < resp.length; index++) {
    //       barChartCurrentUser.value.series[0].data.push(resp[index].total);
    //       barChartCurrentUser.value.chartOptions.xaxis.categories.push(resp[index].date);
    //     }
    //     displayChartCurrentUser.value = true;
    //     displayOverlayUserReport.value = false;
    //   }).catch(() => {
    //     displayOverlayUserReport.value = false;
    //   });
    // };

    const fetchReport = () => {
      // displayChart.value = false;
      displayOverlay.value = true;
      // barChart.value.series[0].data = [];
      // barChart.value.chartOptions.xaxis.categories = [];
      const params = buildParams();
      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }
      newsReportService.getReportByUser(params)
        .then((resp) => {
          reportUser.value = resp.data;
          // for (let index = 0; index < resp.data.length; index++) {
          //   barChart.value.series[0].data.push(resp.data[index].total);
          //   barChart.value.chartOptions.xaxis.categories.push(
          //     resp.data[index].user.name
          //   );
          // }
        
          // displayChart.value = true;
          totalRowsReport.value = resp.totalRows;
          displayOverlay.value = false;
          displayTableReport.value = true;
      }).catch(() => {
        displayOverlay.value = false;
      });
    };
    
    const fetchAllData = () => {
      fetchReport();
      fetchReportByDate();
    }

    const fetchReportByDate = () => {
      // displayChartByDate.value = false;
      displayOverlayBydate.value = true;
      // barChartByDate.value = Object.assign([]);
      const params = buildParams();
      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }
      // if (rangePickerReportByDate.value) {
      //   params.append("dt_range", rangePickerReportByDate.value);
      // }
      newsReportService.getReportByDate(params)
      .then((resp) => {
        // listData.value = resp;
        // for (let index = 0; index < resp.length; index++) {
        //   let data = Object.assign({}, defaultBarChart.value);
        //   data.user = resp[index].user;
        //   data.series[0].data = resp[index].data.map(item => item.total);
        //   data.chartOptions.xaxis.categories = resp[index].data.map(item => item.date);
        //   // for (let j = 0; j < resp[index].data.length; j++) {
        //   //   data.series[0].data.push(resp[index].data[j].total);
        //   //   data.chartOptions.xaxis.categories.push(resp[index].data[j].date);
        //   // }
        //   barChartByDate.value.push(Object.assign({}, data));
        //   data = null;
        // }
        reportUserByDate.value = resp
        totalRowsReportByDate.value = resp.totalRows;
        displayOverlayBydate.value = false;
        displayTableReportByDate.value = true;
      }).catch(() => {
        displayOverlayBydate.value = false;
      });
    };

    const reportData = () => {
      const params = buildParams();
      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }

      params.append("download", true);
      newsReportService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'relatorio_total_por_usuario.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    };
    const onClear= () => {
      rangePicker.value = "";
      eventStatusFilter.value = "";
      userFilter.value = [];
    };

    fetchFilter();

    

    return {
      // variables

      // displayOverlayUserReport,
      displayOverlayBydate,
      displayOverlay,
      displayFilters,
      // displayChart,
      // displayChartByDate,
      // displayChartCurrentUser,
      perfectScrollbarSettings,
      rangePicker,
      // rangePickerReportByDate,
      // rangePickerReportCurrentUser,
      // barChart,
      // barChartByDate,
      // barChartCurrentUser,
      origins,
      subjects,
      users,
      eventStatus,
      layouts,
      agency,

      agencyFilter,
      originFilter,
      subjectFilter,
      userFilter,
      importantFilter,
      flashesFilter,
      eventStatusFilter,
      layoutFilter,
      // listData,
      pageReport,
      pageReportByDate,
      displayTableReport,
      displayTableReportByDate,
      totalRowsReport,
      totalRowsReportByDate,
      limit,
      fieldsReport,
      reportUser,
      reportUserByDate,

      // methods
      fetchReport,
      fetchReportByDate,
      // fetchCurrentUserReport,
      fetchAllData,
      onChangePageReport,
      onChangePageReportByDate,
      reportData,
      onClear
    };
  },
};
</script>

<style>
.report-user-content-filter .calendar-analytics-report-by-user {
  padding-left: 11px;
  padding-right: 11px;
  /* position: relative; */
}

.report-user-content-filter .row {
  align-items: center;
  /* position: relative */
}

.search-button-report-by-user button {
  margin-right: 10px;
}

.report-user-scroll-area.repor-by-user {
  height: 55% !important;
}

.search-button-report-by-user {
  padding: .5rem;
}

</style>
